import React, { FC, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { ClipBoardWrapper, Table, TableSkeleton } from '../../../components'
import { staffObjectStorageService } from '../../../api'
import { SecretKey } from '../../../api/staffObjectStorageService'
import { useUi } from '../../../context/ui.context'
import { Content, EmptyText, SecretValue } from './styles'
import { getObjectStorageError } from './utils'

const ObjectUserTokens: FC<{ objectUserId: string }> = ({ objectUserId }) => {
  const [t] = useTranslation()
  const { viewAlert } = useUi()
  const [tokens, setTokens] = useState<SecretKey[]>([])
  const [pageLoading, setPageLoading] = useState(true)

  useEffect(() => {
    staffObjectStorageService.getUserTokens(objectUserId)
      .then(({ data }) => setTokens(data))
      .catch((error) => viewAlert({
        severity: 'error',
        message: getObjectStorageError(error, t('ERROR_OCCURRED')),
      }))
      .finally(() => setPageLoading(false))
  }, [objectUserId])

  const columns = [
    { title: t('ACCESS_KEY'), key: 'access_key_display' },
    { title: t('SECRET_KEY'), key: 'secret_key_display' },
  ]
  const rows = tokens.map((token) => ({
    id: token.access_key,
    access_key_display: (
      <ClipBoardWrapper toCopy={token.access_key}>
        <SecretValue>{token.access_key}</SecretValue>
      </ClipBoardWrapper>
    ),
    secret_key_display: (
      <ClipBoardWrapper toCopy={token.secret_key}>
        <SecretValue>{token.secret_key}</SecretValue>
      </ClipBoardWrapper>
    ),
  }))

  if (pageLoading) {
    return <TableSkeleton rows={3} columns={columns.length} columnsData={columns} />
  }

  return (
    <Content>
      {rows.length ? (
        <Table columns={columns} rows={rows} hideCheckbox hideOther />
      ) : (
        <EmptyText>{t('NO_S3_KEYS')}</EmptyText>
      )}
    </Content>
  )
}

export default ObjectUserTokens
